import { createContext } from "react";

const RootContext = createContext();

export default RootContext;
